// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-size: 20px;
  border-radius: 50%;
  line-height: 16px;
  transform: rotate(45deg);
  transition: all 0.1s ease;
  cursor: pointer;
}
.close-icon:hover {
  background: rgba(0, 0, 0, 0.8);
  color: #fff6f6;
}`, "",{"version":3,"sources":["webpack://./src/Components/CloseIcon/CloseIcon.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,eAAA;AACF;AACE;EACE,8BAAA;EACA,cAAA;AACJ","sourcesContent":[".close-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  font-size: 20px;\n  border-radius: 50%;\n  line-height: 16px;\n  transform: rotate(45deg);\n  transition: all 0.1s ease;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n    color: #fff6f6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
